var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 2.40002H3.5999C2.9369 2.40002 2.3999 2.93702 2.3999 3.60002V14.4C2.3999 15.063 2.9369 15.6 3.5999 15.6H14.3999C15.0629 15.6 15.5999 15.063 15.5999 14.4V3.60002C15.5999 2.93702 15.0629 2.40002 14.3999 2.40002ZM10.1999 12H5.3999C5.0687 12 4.7999 11.7312 4.7999 11.4C4.7999 11.0688 5.0687 10.8 5.3999 10.8H10.1999C10.5311 10.8 10.7999 11.0688 10.7999 11.4C10.7999 11.7312 10.5311 12 10.1999 12ZM12.5999 9.60002H5.3999C5.0687 9.60002 4.7999 9.33122 4.7999 9.00002C4.7999 8.66882 5.0687 8.40002 5.3999 8.40002H12.5999C12.9311 8.40002 13.1999 8.66882 13.1999 9.00002C13.1999 9.33122 12.9311 9.60002 12.5999 9.60002ZM12.5999 7.20002H5.3999C5.0687 7.20002 4.7999 6.93122 4.7999 6.60002C4.7999 6.26882 5.0687 6.00002 5.3999 6.00002H12.5999C12.9311 6.00002 13.1999 6.26882 13.1999 6.60002C13.1999 6.93122 12.9311 7.20002 12.5999 7.20002Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.f4fa6386bd7b2c99604bccc11cdb8ccf.svg";
export { ForwardRef as ReactComponent };